import List from './src/List'
List.install = (Vue) => {
  Vue.component(List.name, List)
}
export default List



// WEBPACK FOOTER //
// ./packages/material-list/index.js